import { logoStyles } from "@insite/content-library/Widgets/Basic/Logo";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

Object.assign(logoStyles, {
    ...logoStyles,
    wrapper: {
        css: css`
            max-width: 110px;
            max-height: 110px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            max-width: none;
                        `,
                    ],
                    "max",
                )}
        `,
    },
    image: {
        css: css`
            width: 100%;
        `,
    },
});
